import(/* webpackMode: "eager" */ "/build/b8d6cc83-0b1e-47b5-a97e-83e2368995c2/src/app/[locale]/(simulation)/simulateur/[root]/page.tsx");
